import { Box } from '@mui/material';
import { Link } from 'found';
import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import type { AsyncActionStatus } from '../../actions/common.actionTypes';
import { customSizes } from '../../assets/styles/themes/tokens';
import { routes } from '../../constants';
import { CollectionFormModalContext } from '../../state/CollectionFormModalProvider';
import type { CollectionProperties } from '../../types/AppContent';
import useResponsivePadding from '../../utils/useResponsivePadding';
import CollectionsAppLayout from '../AppLayout/Collections/CollectionsAppLayout';
import CollectionsTabs from '../AppLayout/Collections/CollectionsTabs';
import MasterLayout from '../AppLayout/MasterLayout';
import EmptySearchStateImage from '../Search/SearchResults/EmptySearchResultsNewUI/EmptySearchStateImage';
import MyCollectionsAddButton from './MyCollectionsAddButton';
import MyCollectionsList from './MyCollectionsList';

interface MyCollectionsProps {
	collectionsStatus: AsyncActionStatus;
	collections: CollectionProperties[];
}

const MyCollections: React.FC<MyCollectionsProps> = (props) => {
	const { collectionsStatus, collections } = props;
	const { t } = useTranslation();
	const { show: openCollectionFormModal } = useContext(CollectionFormModalContext);
	const contentPadding = useResponsivePadding();

	const renderMyCollections = () => {
		if (collectionsStatus !== 'loading' && (!collections || !collections.length)) {
			return (
				<EmptySearchStateImage
					title={t('no collections yet')}
					subtitle={
						<Trans i18nKey="Create your own collection or follow curated collections" key={1}>
							<Link to={`/${routes.curatedCollections.root}`} />
						</Trans>
					}
					subtitleSx={{
						maxWidth: customSizes.emptyStateSubtitleMaxWidth,
						textAlign: 'center',
					}}
					iconName="emptyState"
				/>
			);
		}

		return <MyCollectionsList collections={collections} />;
	};

	return (
		<Box data-testid="own-collection-overview-page">
			<MasterLayout isNewMerklistePage={true}>
				<CollectionsAppLayout
					title={t('Saved')}
					tabs={<CollectionsTabs activeTab={routes.collections.root} isNewDesignEnabled={true} />}
					isSearchPageContainer={true}
					headerButton={
						<MyCollectionsAddButton openCollectionFormModal={() => openCollectionFormModal()} />
					}
				>
					<Box sx={{ padding: contentPadding }}>{renderMyCollections()}</Box>
				</CollectionsAppLayout>
			</MasterLayout>
		</Box>
	);
};

export default MyCollections;
